import { CampaignStatus } from '@/shared/types/campaigns';

export type CampaignDetailPage = 'setup' | 'analytics';

/**
 * Decides which campaign detail page a campaigns-table row should open.
 *
 * - Editable statuses (`draft` / `ready`) open **Setup** so the user can keep configuring.
 * - Every other status opens **Analytics**: the active `in_progress` and the terminal
 *   `sent` / `canceled` / `failed`. A `failed` campaign is terminal in the orchestrator
 *   (no transitions out, no retry path), so there is nothing to edit — it shows results
 *   alongside the other completed campaigns.
 * - An unknown or missing status falls back to **Analytics** (read-only) rather than risk
 *   opening an editable Setup for a campaign in an unexpected state.
 */
export const getCampaignDetailPage = (
  status?: CampaignStatus | string | null
): CampaignDetailPage => {
  const normalized = status?.toLowerCase();
  const isEditable = normalized === 'draft' || normalized === 'ready';
  return isEditable ? 'setup' : 'analytics';
};
